import React, { Fragment } from 'react';

import BreadcrumbNavigationContainer from './breadcrumb_navigation_container.jsx';

import ErrorBoundary from 'zoomforth_component_lib/error_boundary_internal.jsx';

export default ({ children, isInsideTab = false }) => (
  <Fragment>
    {!isInsideTab && <BreadcrumbNavigationContainer />}
    <ErrorBoundary>
      {children}
    </ErrorBoundary>
  </Fragment>
);
